import { useState, useEffect, useMemo } from 'react'
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Radio,
  Divider,
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";
import { getApprovedProjects } from "../../redux/actions/financeAction"
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CancelIcon from '@material-ui/icons/Cancel';

const NON_EDITABLE_MATERIALS = [
  "minifix",
  "wooden dowel",
  "edge glue 280.50",
  "beam saw sticker 100 x 75",
  "packaging roll - bubble roll",
  "packaging tape",
  "d3 adhesive"
];


const BomSegregation = (props) => {
  const { approvedProjects } = useSelector(state => state.finance)
  const { userDetails } = useSelector(state => state.user)
  const [optimizationName, setOptimizationName] = useState([]);
  const [uploadedMaterialBom, setUploadedMaterialBom] = useState("");
  const [uploadedOptimizationBom, setUploadedOptimizationBom] = useState("");
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);
  const [selectedProjectObjects, setSelectedProjectObjects] = useState([]);
  const [materialBomUploaded, setMaterialBomUploaded] = useState(false);
  const [optimizationBomUploaded, setOptimizationBomUploaded] = useState(false);
  const [isSegregated, setIsSegregated] = useState(false);
  const [resetDialogOpen, setResetDialogOpen] = useState(false);
  const [summaryDialogOpen, setSummaryDialogOpen] = useState(false);
  const [projectSummary, setProjectSummary] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [customTableOpen, setCustomTableOpen] = useState(false);
  const [editableData, setEditableData] = useState([]);
  const [confirmSubmitOpen, setConfirmSubmitOpen] = useState(false);
  const [initialRowValues, setInitialRowValues] = useState({});
  const [qtyChangeLogs, setQtyChangeLogs] = useState({});
  const [uploadedId, setUploadedId] = useState("");
  const [openERPDialog, setOpenERPDialog] = useState(false);
  const [bomStatus, setBomStatus] = useState({});
  const [uploadStatus, setUploadStatus] = useState({});
  const [bomsCreated, setBomsCreated] = useState([]);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewBomData, setViewBomData] = useState([]);
  const [viewProject, setViewProject] = useState(null);
  const [uploadedBoms, setUploadedBoms] = useState([]);
  const [segregationBtnActive, setSegregationBtnActive] = useState(false);
  const [allOptimisionData, setAllOptimisionData] = useState([]);
  const [allApprovalBoms, setAllApprovalBoms] = useState([]);
  const [refreshTable, setRefreshTable] = useState(0);
  const [autoApprovalBtnDisabled, setAutoApprovalBtnDisabled] = useState(false);
  const [imosData, setImosData] = useState([]);
  const [bomData, setBomData] = useState([]);


  useEffect(() => {
    if (allApprovalBoms && allApprovalBoms.length > 0) {
      setRefreshTable(prev => prev + 1);
    }
  }, [allApprovalBoms]);

  useEffect(() => {
      props.getApprovedProjects()
      getOptimisationFiles()
  }, [])

  const getOptimisationFiles = async () => {
    props.setLoading(true)
    try {
      let response = await HttpService.getOptimisationFiles()
      setAllOptimisionData(response.data.optimisationFiles)
    }
    catch (error) {
      console.error("error", error)
    }
    props.setLoading(false)
  }
  
  const handleUploadFile = async(e, fileType)=>{
      props.setLoading(true)
      try{
          const fd = new FormData();
          fd.append('file', e.target.files[0]);
          const res = await HttpService.uploadFile(fd);
          if (fileType === "Material BOM") {
            setUploadedMaterialBom(res?.data)
            setMaterialBomUploaded(true);
          } else {
            setUploadedOptimizationBom(res?.data)
            setOptimizationBomUploaded(true);
          }
      }
      catch(err){
          props.setSnackInfo("Something went wrong","error");
      }
      props.setLoading(false);
  }

  const handleSegregate = async () => {
    props.setLoading(true);

    try {
      const payload = {
        projectIds: selectedProjectIds,
        optimizationName:optimizationName?.[0]?.optimizationNumber,
        materialBomFile: optimizationName?.[0]?.pastingListBOMFile,
        optimizationBomFile: optimizationName?.[0]?.excelFileLink,
        userId: userDetails?._id,
        imosFile: optimizationName,
        uploadedId: uploadedId,
      };

      const res = await HttpService.segregateHandleBom(payload);
      if (res?.data?.success) {
        setSegregationBtnActive(true);
        setIsSegregated(true);
        setProjectSummary(res?.data?.data || []);
        setCsvData(res?.data?.projectResults || [])
        setUploadedId(res?.data?.bomSegregationDBSaveId || "")
        setImosData(res?.data?.IMOSFileData || [])
        setBomData(res?.data?.bomData || [])
        const successMessage = res?.data?.message || "Something went wrong";
        props.setSnackInfo(successMessage, "success");
      } else {
        props.setSnackInfo(res?.data?.message || "Segregation failed", "error");
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || "Something went wrong";
      props.setSnackInfo(errorMessage, "error");
    }
    props.setLoading(false);
  };

  const selectedOptimizationNumber = optimizationName?.[0]?.optimizationNumber?.trim() || "";

  const isSegregateEnabled =
  selectedProjectIds.length > 0 &&
  selectedOptimizationNumber.trim()

  const handleReset = () => {
    setSelectedProjectObjects([]);
    setSelectedProjectIds([]);
    setOptimizationName([]);
    setUploadedMaterialBom("");
    setUploadedOptimizationBom("");
    setUploadedId("")
    setSegregationBtnActive(false)
    setMaterialBomUploaded(false);
    setOptimizationBomUploaded(false);
    setIsSegregated(false);
    setResetDialogOpen(false);
  };

  const isRowEditable = (row) => {
    const material = row.__EMPTY_1?.toLowerCase() || "";
    return !NON_EDITABLE_MATERIALS.some(item => material.includes(item));
  };

  const markHeaderColumnAsYes = (updatedData, key) => {
    if (
      updatedData.length > 0 &&
      updatedData[0][key] === "No"
    ) {
      updatedData[0][key] = "Yes";
    }
  };

  const handleDownloadExcel = async () => {
    try {
      props.setLoading(true);

      const res = await HttpService.downloadSegregatedBomExcel({
        csvData,
        optimizationName:optimizationName?.[0]?.optimizationNumber,
        userId: userDetails?._id,
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute(
        "download",
        `${optimizationName?.[0]?.optimizationNumber || "BOM_Segregation"}.xlsx`
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (err) {
      props.setSnackInfo("Excel download failed", "error");
    }
    props.setLoading(false);
  };

  const isEditableColumn = (keys, key) => {
    const editableStartIndex = keys.indexOf("__EMPTY_4");
    return editableStartIndex !== -1 && keys.indexOf(key) > editableStartIndex;
  };

  const MAX_INCREMENT = 14;

  const materialList = [
    "12mm-Comm Plywood-7x4",
    "25mm-Comm Plywood-8x4",
    "25mm MDF-Interior grade-8x4",
    "17mm MDF-Interior grade-8x4",
    "8x4 HDHMR 17mm",
    "25mm flush door",
    "4mm hdhmr",
    "25mm hdhmr",
    "HDHMR - 16mm 8x4",
    "6mm-Comm Plywood-8x4",
    "6mm-BWP Plywood-8x4",
    "16mm-Comm Plywood-8x4",
    "19mm-Block Board-8x4",
    "19mm-Block Board-7x4",
    "25mm RUBBER WOOD",
    "25mm-BWP Plywood-8x4",
    "4mm MDF-Interior grade-8x4",
    "16mm-Century Sainik MR-8x4",
    "16mm-Century Clubprime BWP-8x4",
    "16mm-GreenPly Absolute BWP-8x4",
    "12mm FLEXI PLY - comm",
    "6mm-Flexi Ply Plywood-8x4",
    "16mm-BWP Plywood-8x4",
    "17mm Rubber Wood - 8x4",
    "7.5 MM Prelam grey ply boards",
    "18 MM Prelam grey ply boards",
    "16mm Eucalyptus Plywood 8x4",
    "6MM raw Ply",
    "25mm Flush Door 7x4",
    "16mm-Century Maxima MR-8x4"
  ];

  const handleCellChange = (rowIndex, key, value) => {
    setEditableData(prev => {
      const updated = [...prev];
      const row = updated[rowIndex];

      if (!isDataRow(row) || !row.__rowActive) return prev;

      const keys = Object.keys(row).filter(k => !["__rowActive"].includes(k));
      const editableStartIndex = keys.indexOf("__EMPTY_4");
      if (keys.indexOf(key) <= editableStartIndex) return prev;

      const oldValue = Number(row[key] || 0);
      let newValue = Number(value);

      // Prevent decrease
      if (newValue <= oldValue) return prev;

      // Get the initial value for this specific cell (using rowIndex and key)
      const rowKey = `${rowIndex}-${key}`;
      const initialValue = initialRowValues[rowKey] !== undefined ? initialRowValues[rowKey] : oldValue;
      
      // Calculate how many times we've incremented from the initial value
      const incrementCount = newValue - initialValue;
      
      // Cap at MAX_INCREMENT (14 times max)
      if (incrementCount > MAX_INCREMENT) {
        return prev; // Don't allow increment beyond 14
      }

      const delta = newValue - oldValue;

      // Update ONLY this specific row and cell
      row[key] = newValue;
      row.__EMPTY_3 = Number(row.__EMPTY_3 || 0) + delta;

      // Log qty change: projectName / oldQty / newQty / increasedQty (aggregated per cell)
      const projectName = updated[3]?.[key] ?? "";
      setQtyChangeLogs(prevLogs => {
        const existing = prevLogs[rowKey];
        const baseOldQty = existing ? existing.oldQty : oldValue;
        return {
          ...prevLogs,
          [rowKey]: {
            projectName,
            materialName: row.__EMPTY_1 || "",
            oldQty: baseOldQty,
            newQty: newValue,
            increasedQty: Number((newValue - baseOldQty).toFixed(2)),
          }
        };
      });

      // Check if this is a material row that should trigger D3 Adhesive increase
      const currentMaterial = row.__EMPTY_1?.toLowerCase() || "";
      const isMaterialRow = materialList.some(item =>
        currentMaterial.includes(item.toLowerCase())
      );

      if (isMaterialRow) {
        // Find D3 Adhesive row
        const d3RowIndex = updated.findIndex(r => 
          isDataRow(r) && (r.__EMPTY_1?.toLowerCase() || "").includes("d3 adhesive")
        );

        if (d3RowIndex !== -1) {
          const d3Row = updated[d3RowIndex];
          
          // Increase ONLY the matched column in D3 Adhesive row by 1.1
          const d3OldValue = Number(d3Row[key] || 0);
          const d3NewValue = Number((d3OldValue + 1.1).toFixed(2));
          d3Row[key] = d3NewValue;
          d3Row.__EMPTY_3 = Number(d3Row.__EMPTY_3 || 0) + 1.1;

          // Update D3 header rows for this specific column
          updated.forEach((headerRow, index) => {
            if (headerRow.__EMPTY === "Clint ID" && headerRow.hasOwnProperty(key)) {
              headerRow[key] = "Custom Updated";
            }
            if (headerRow.__EMPTY === "Sl.no" && headerRow.hasOwnProperty(key)) {
              headerRow[key] = "Yes";
            }
          });
        }
      }

      // Update header rows - check __EMPTY value to identify which header row
      updated.forEach((headerRow, index) => {
        if (headerRow.__EMPTY === "Clint ID" && headerRow.hasOwnProperty(key)) {
          headerRow[key] = "Custom Updated";
        }
        if (headerRow.__EMPTY === "Sl.no" && headerRow.hasOwnProperty(key)) {
          headerRow[key] = "Yes";
        }
      });

      markHeaderColumnAsYes(updated, key);

      return updated;
    });
  };

  // Project columns start at __EMPTY_5 and are read from the project header row
  const getProjectColumns = () => {
    const headerRow = editableData[3] || {};
    const columns = [];
    let colIndex = 5;
    while (headerRow[`__EMPTY_${colIndex}`] !== undefined) {
      const projectName = headerRow[`__EMPTY_${colIndex}`];
      if (projectName && String(projectName).trim() !== "" && isNaN(projectName)) {
        columns.push({ key: `__EMPTY_${colIndex}`, projectName: String(projectName).trim() });
      }
      colIndex++;
    }
    return columns;
  };

  // One record per project, listing the materials customised in it. A material
  // appearing in several rows is summed, so oldQty/newQty are that material's
  // total for the project before and after the customs. priority ranks the
  // projects that customised the same material (1 = biggest increase).
  const buildAggregatedQtyLogs = () => {
    if (Object.keys(qtyChangeLogs).length === 0) return [];

    const projectColumns = getProjectColumns();
    const totals = {};

    editableData.forEach((row, rowIndex) => {
      if (!isDataRow(row)) return;

      const materialName = String(row.__EMPTY_1 || "").trim();
      if (!materialName) return;

      projectColumns.forEach(({ key, projectName }) => {
        const changed = qtyChangeLogs[`${rowIndex}-${key}`];
        const currentQty = Number(row[key] || 0);
        // Baseline is the value logged before the first edit, else the untouched cell
        const originalQty = changed ? Number(changed.oldQty || 0) : currentQty;

        const groupKey = `${projectName}||${materialName}`;
        if (!totals[groupKey]) {
          totals[groupKey] = { projectName, materialName, oldQty: 0, newQty: 0, customCount: 0 };
        }
        totals[groupKey].oldQty += originalQty;
        totals[groupKey].newQty += currentQty;
        if (changed) totals[groupKey].customCount += 1;
      });
    });

    const entries = Object.values(totals)
      .filter(entry => entry.customCount > 0)
      .map(entry => ({
        projectName: entry.projectName,
        materialName: entry.materialName,
        oldQty: Number(entry.oldQty.toFixed(2)),
        newQty: Number(entry.newQty.toFixed(2)),
        increasedQty: Number((entry.newQty - entry.oldQty).toFixed(2)),
        customCount: entry.customCount,
      }));

    // Rank the projects that customised the same material, biggest increase first
    const byMaterial = {};
    entries.forEach(entry => {
      if (!byMaterial[entry.materialName]) byMaterial[entry.materialName] = [];
      byMaterial[entry.materialName].push(entry);
    });

    Object.values(byMaterial).forEach(group => {
      [...group]
        .sort((a, b) => b.increasedQty - a.increasedQty)
        .forEach((entry, index) => {
          entry.priority = index + 1;
        });
    });

    // One record per project, holding that project's customised materials
    const byProject = {};
    entries.forEach(entry => {
      if (!byProject[entry.projectName]) {
        byProject[entry.projectName] = { projectName: entry.projectName, materials: [] };
      }
      byProject[entry.projectName].materials.push({
        materialName: entry.materialName,
        oldQty: entry.oldQty,
        newQty: entry.newQty,
        increasedQty: entry.increasedQty,
        customCount: entry.customCount,
        priority: entry.priority,
      });
    });

    return Object.values(byProject);
  };

  const handleSubmitCustomTable = async () => {
    props.setLoading(true);
    // Update main CSV data with edited values
    setCsvData(JSON.parse(JSON.stringify(editableData)));
    // Close dialog
    setCustomTableOpen(false);

    try {
      const payload = {
        customData: editableData,
        isCustom: true,
        updateId: uploadedId,
        qtyChangeLogs: buildAggregatedQtyLogs(),
        optimizationId: optimizationName?.[0]?._id,
      };

      const res = await HttpService.segregateHandleBom(payload);
      if (res?.data?.success) {
        setIsSegregated(true);
        setCsvData(res?.data?.projectResults || [])
        const successMessage = res?.data?.message || "Something went wrong";
        props.setSnackInfo(successMessage, "success");
      } else {
        props.setSnackInfo(res?.data?.message || "Segregation failed", "error");
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || "Something went wrong";
      props.setSnackInfo(errorMessage, "error");
    }
    props.setLoading(false);
  };

  const toggleRowActive = (rowIndex) => {
    setEditableData(prev => {
      const updated = [...prev];
      const row = updated[rowIndex];

      if (!isDataRow(row)) return prev;

      row.__rowActive = !row.__rowActive;

      // Store initial values when row is activated
      if (row.__rowActive) {
        const keys = Object.keys(row).filter(k => !["__rowActive"].includes(k));
        const newInitialValues = { ...initialRowValues };
        keys.forEach(key => {
          const rowKey = `${rowIndex}-${key}`;
          if (newInitialValues[rowKey] === undefined) {
            newInitialValues[rowKey] = Number(row[key] || 0);
          }
        });
        setInitialRowValues(newInitialValues);
      }

      return updated;
    });
  };

  const isDataRow = (row) =>
    /^\d+$/.test(String(row.__EMPTY || ""));

  const isHiddenMaterialRow = (row) => {
    const material = row.__EMPTY_1?.toLowerCase() || "";
    return NON_EDITABLE_MATERIALS.some(item =>
      material.includes(item)
    );
  };


  // This is for project wise bom file cration.
  const bomFileCreationAPI = async () => {
    props.setLoading(true);
    try {
      const payload = {
        selectedProjectId: selectedProjectIds,
        uploadedId: uploadedId
      };
      const res = await HttpService.segregatedBomFileCreation(payload);
      if (res?.data?.success) {
        setBomsCreated(res?.data?.data);
        props.setSnackInfo(res.data.message || "BOM file created successfully", "success");
      } else {
        props.setSnackInfo(res.data.message || "Segregation failed", "error");
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message || err?.message || "Something went wrong";
      props.setSnackInfo(errorMsg, "error");
    } finally {
      props.setLoading(false);
    }
  };

  const handleViewBOM = (project) => {
    const projectBom = bomsCreated.find(
      b => b.projectNumber === project.projectNumber
    );
    setViewProject(project);
    setViewBomData(projectBom?.bomItems || []);
    setOpenViewDialog(true);
  };

  const bomFileAutoUploadAPI = async () => {
    setAutoApprovalBtnDisabled(true);
    props.setLoading(true);
    try {
      const payload = {
        bomType: "Modular BOM",
        bomFiles: bomsCreated,
        uploadedId: uploadedId,
        projectIds: selectedProjectIds,
        userId: userDetails?._id,
        imosFile: optimizationName,
        optimizationId: optimizationName?.[0]?._id,
      };
      const res = await HttpService.segregatedBomFileAutoUplaod(payload);
      if (res?.data?.success) {
        setUploadedBoms(res?.data?.uploadResults || []);
        const approvalData = res?.data?.autoApproveResult?.projectStatus || [];
        setAllApprovalBoms(approvalData);
        props.setSnackInfo(res.data.message || "BOM file created successfully", "success");
        if (res?.data?.autoApproveResult?.message) {
          props.setSnackInfo(res?.data?.autoApproveResult?.message, "success");
        } else if (res?.data?.autoApproveResult === null) {
          props.setSnackInfo(
            "Please check whether the IMOS file is correct and in the proper format.",
            "warning"
          );
        }
      } else {
        props.setSnackInfo(res.data.message || "Segregation failed", "error");
      }
      
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message || err?.message || "Something went wrong";
      props.setSnackInfo(errorMsg, "error");
    } finally {
      props.setLoading(false);
    }
  };

  const downloadMaterialExcel = () => {
    let csv = "All Material,BOM QTY,IMOS QTY\n";

    Object.keys(bomData).forEach((key) => {
      if (
        key !== "allLaminateSum" &&
        key !== "allPlySum" &&
        key !== "plyDetails" &&
        key !== "laminateDetails"
      ) {
        csv += `${key},${bomData[key] || 0},${imosData[key] || 0}\n`;
      }
    });

    csv += `Laminate,${bomData.allLaminateSum || 0},${imosData.Laminate || 0}\n`;
    csv += `Plywood,${bomData.allPlySum || 0},${imosData.Plywood || 0}\n`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Material_Comparison.csv";
    link.click();
  };

    return (
      <>
        <Box
          display="flex"
          justifyContent="center"
          minHeight="100vh"
          bgcolor="#eef1f6"
          padding={3}
          style={{ paddingTop: 40 }}
        >
          <Card
            elevation={6}
            style={{
              width: "100%",
              maxWidth: 1200,
              borderRadius: 16,
            }}
          >
            <CardContent style={{ padding: 36 }}>
              <Box textAlign="center" mb={4}>
                <Typography variant="h4" style={{ fontWeight: 700 }}>
                  BOM Segregation
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Upload BOM's files and Perform project-wise material segregation.
                </Typography>
              </Box>

              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    id="project-search-dropdown"
                    options={approvedProjects || []}
                    value={selectedProjectObjects}
                    getOptionLabel={(option) => option.searchName || ""}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    onChange={(event, value) => {
                      setSelectedProjectObjects(value);              
                      setSelectedProjectIds(value.map(v => v._id));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Project"
                        variant="outlined"
                        placeholder="Type project name"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Autocomplete
                    id="optimization-search-dropdown"
                    options={allOptimisionData || []}
                    filterOptions={(options, state) =>
                      options.filter(opt =>
                        opt.optimizationNumber
                          ?.toLowerCase()
                          .includes(state.inputValue.toLowerCase()) ||
                        opt.projects
                          ?.toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      )
                    }
                    getOptionLabel={(option) => option?.optimizationNumber || ""}
                    value={optimizationName[0] || null}
                    isOptionEqualToValue={(option, value) =>
                      option._id === value._id
                    }
                    onChange={(event, value) => {
                      setOptimizationName(value ? [value] : []);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Unique Optimization File Name"
                        variant="outlined"
                        placeholder="Search optimization number or project"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                {/* <Grid item xs={12}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={8}>
                      <Typography variant="subtitle1">
                        Material BOM File
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Button variant="outlined" component="label" fullWidth>
                        Upload
                        <input
                          type="file"
                          accept=".csv, .xls, .xlsx"
                          hidden
                          onChange={(e) => handleUploadFile(e, "Material BOM")}
                        />
                      </Button>
                    </Grid>

                    <Grid item xs={1}>
                      <Radio
                        checked={materialBomUploaded}
                        style={{
                          color: materialBomUploaded ? "green" : "#bbb",
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid> */}

                {/* <Grid item xs={12}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={8}>
                      <Typography variant="subtitle1">
                        Optimization File (overall combined project file)
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Button variant="outlined" component="label" fullWidth>
                        Upload
                        <input
                          type="file"
                          accept=".csv, .xls, .xlsx"
                          hidden
                          onChange={(e) => handleUploadFile(e, "Optimization File")}
                        />
                      </Button>
                    </Grid>

                    <Grid item xs={1}>
                      <Radio
                        checked={optimizationBomUploaded}
                        style={{
                          color: optimizationBomUploaded ? "green" : "#bbb",
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid> */}

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={8}>
                      <Typography variant="subtitle1">
                        You Want to Custom Input for This Segregation?
                      </Typography>
                    </Grid>

                    <Grid item xs={3}>
                      <Button  
                        component="label" 
                        fullWidth
                        variant="contained"
                        disabled={!isSegregated}
                        onClick={() => {
                          setEditableData(
                            csvData.map((row, index) => ({
                              ...row,
                              __rowActive: false
                            }))
                          );
                          setInitialRowValues({});
                          setQtyChangeLogs({});
                          setCustomTableOpen(true);
                        }}
                        style={{
                          backgroundColor: !isSegregated ? "#d2d3d5ff" : "#1c375d",
                          color: !isSegregated ? "#rgb(132 123 122)" :  "#fff",
                          fontWeight: 600
                        }}>
                        yes
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                <Divider />
                </Grid>


                <Grid item xs={12}>
                  <Grid container spacing={2} mt={3}>
                    <Grid item xs={12} sm={6} md={2.4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={!isSegregateEnabled || segregationBtnActive}
                        onClick={handleSegregate}
                      >
                        Segregate
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="inherit"
                        disabled={!isSegregated}
                        onClick={handleDownloadExcel}
                      >
                        Download Excel
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={!isSegregated}
                        onClick={() => setOpenERPDialog(true)}
                      >
                        Auto Upload to ERP
                      </Button>
                    </Grid>  

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={!isSegregated}
                        onClick={() => setSummaryDialogOpen(true)}
                      >
                        View Summary
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2.4}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        onClick={() => setResetDialogOpen(true)}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Dialog
            open={resetDialogOpen}
            onClose={() => setResetDialogOpen(false)}
          >
            <DialogTitle>Confirm Reset</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to reset all inputs?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setResetDialogOpen(false)} color="default">
                No
              </Button>
              <Button onClick={handleReset} color="secondary" variant="contained">
                Yes, Reset
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={summaryDialogOpen}
            onClose={() => setSummaryDialogOpen(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle
              style={{
                backgroundColor: "#1c375d",
                color: "#ffffff",
                fontWeight: 700,
                fontSize: 18
              }}
            >
              Project-wise Optimization Summary
            </DialogTitle>

            <DialogContent style={{ padding: 24 }}>
              <TableContainer
                component={Card}
                elevation={4}
                style={{ borderRadius: 12 }}
              >
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#f1f4f9" }}>
                      <TableCell style={{ fontWeight: 700 }}>
                        Project ID
                      </TableCell>
                      <TableCell align="right" style={{ fontWeight: 700 }}>
                        Count
                      </TableCell>
                      <TableCell align="right" style={{ fontWeight: 700 }}>
                        Percentage
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {projectSummary.map((row, index) => {
                      const isTotal = row.projectId === "Grand Total";

                      return (
                        <TableRow
                          key={index}
                          hover
                          style={{
                            backgroundColor: isTotal ? "#e9eef6" : "inherit"
                          }}
                        >
                          <TableCell
                            style={{
                              fontWeight: isTotal ? 700 : 500,
                              color: isTotal ? "#1c375d" : "#333"
                            }}
                          >
                            {row.projectId}
                          </TableCell>

                          <TableCell
                            align="right"
                            style={{
                              fontWeight: isTotal ? 700 : 500
                            }}
                          >
                            {row.count}
                          </TableCell>

                          <TableCell
                            align="right"
                            style={{
                              fontWeight: isTotal ? 700 : 500
                            }}
                          >
                            {row.percentage}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>

            <DialogActions style={{ padding: 16 }}>
              <Button
                onClick={downloadMaterialExcel}
                variant="contained"
                style={{
                  backgroundColor: "#2e7d32",
                  color: "#fff",
                  fontWeight: 600,
                  marginRight: 8
                }}
              >
                Download Excel BOM Quantities vs IMOS Quantities Comparison
              </Button>
              <Button
                onClick={() => setSummaryDialogOpen(false)}
                variant="contained"
                style={{
                  backgroundColor: "#1c375d",
                  color: "#fff",
                  fontWeight: 600
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={customTableOpen}
            onClose={() => setCustomTableOpen(false)}
            fullWidth
            maxWidth="xl"
          >
            <DialogTitle
              style={{
                backgroundColor: "#1c375d",
                color: "#fff",
                fontWeight: 700
              }}
            >
              Custom BOM Segregation Table
            </DialogTitle>

            <DialogContent style={{ padding: 16 }}>
              <TableContainer component={Card} elevation={3} style={{ overflowX: "auto" }}>
                <Table size="small">
                  <TableBody>
                    {editableData.map((row, actualRowIndex) => {
                      const keys = Object.keys(row).filter(
                        k => !["__rowActive"].includes(k)
                      );

                      return (
                        <TableRow key={actualRowIndex}>
                          {keys.map((key, colIndex) => {
                            const editable =
                            isDataRow(row) &&
                            row.__rowActive &&
                            isEditableColumn(keys, key) &&
                            key !== "__EMPTY_3" &&     // IMPORTANT: qty never editable
                            isRowEditable(row);

                            const isNumber = typeof row[key] === "number";

                            // Handle Sl.no column with checkbox
                            if (key === "__EMPTY") {
                              const isHidden = isHiddenMaterialRow(row);
                              return (
                                <TableCell
                                  key={colIndex}
                                  style={{
                                    border: "1px solid #ddd",
                                    minWidth: 120,
                                    backgroundColor: isHidden ? "#ffe0e0" : "#f5f7fa",
                                    fontWeight: 500
                                  }}
                                >
                                  <Box display="flex" alignItems="center" gap={1}>
                                    {isDataRow(row) && !isHidden && (
                                      <Checkbox
                                        checked={!!row.__rowActive}
                                        onChange={() => toggleRowActive(actualRowIndex)}
                                        color="primary"
                                        size="small"
                                      />
                                    )}
                                    <Typography style={{ color: isHidden ? "#999" : "#000" }}>
                                      {row[key]} {isHidden && "(Non-Editable)"}
                                    </Typography>
                                  </Box>
                                </TableCell>
                              );
                            }

                            if (
                              isDataRow(row) &&
                              !row.__rowActive &&
                              (key === "__EMPTY_2" || key === "__EMPTY_3" || isEditableColumn(keys, key))
                            ) {
                              return <TableCell>0</TableCell>;
                            }

                            // Editable cells
                            const isHidden = isHiddenMaterialRow(row);
                            return (
                              <TableCell
                                  key={colIndex}
                                  style={{
                                    border: "1px solid #ddd",
                                    minWidth: 120,
                                    backgroundColor: editable && !isHidden ? "#ffffff" : isHidden ? "#f0f0f0" : "#f5f7fa",
                                    fontWeight: actualRowIndex === 2 ? 700 : 400,
                                    opacity: isHidden ? 0.6 : 1
                                  }}
                                >
                                {editable && isNumber && !isHidden ? (
                                    <TextField
                                      type="number"
                                      value={row[key]}
                                      onChange={(e) => {
                                        let newValue = Number(e.target.value);
                                        const oldValue = Number(row[key] || 0);

                                        // Only allow increase by +1 increments
                                        if (newValue !== oldValue + 1) return;

                                        handleCellChange(actualRowIndex, key, newValue);
                                      }}
                                      onKeyDown={(e) => {
                                        // Prevent manual typing of "-" or lower numbers
                                        if (e.key === "-" || e.key === "e") e.preventDefault();
                                      }}
                                      size="small"
                                      variant="outlined"
                                      inputProps={{
                                        min: row[key] + 1, // can only increase by 1
                                        step: 1,
                                        readOnly: false,
                                      }}
                                      style={{ width: 80 }}
                                    />
                                  ) : (
                                    row[key]
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setCustomTableOpen(false)}
                variant="contained"
                style={{
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  fontWeight: 600
                }}
              >
                Cancel
              </Button>

              <Button
                onClick={() => setConfirmSubmitOpen(true)}
                variant="contained"
                style={{
                  backgroundColor: "#28a745",
                  color: "#fff",
                  fontWeight: 700
                }}
              >
                Submit Changes
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={confirmSubmitOpen}
            onClose={() => setConfirmSubmitOpen(false)}
          >
            <DialogTitle>Confirm Submission</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to submit the changes? <b>This action cannot be undone.</b>
                <br />
                <b>Create the BOM first.</b> Only after successful BOM creation,
                click <b>Auto Upload to ERP</b>.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setConfirmSubmitOpen(false)}
                color="default"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  handleSubmitCustomTable(); // perform actual submit here
                  setConfirmSubmitOpen(false);
                }}
                color="primary"
                variant="contained"
              >
                Yes, Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* this is for Aut0 upload section */}
          <Dialog
            open={openERPDialog}
            onClose={() => setOpenERPDialog(false)}
            maxWidth="lg"
            fullWidth
          >
            {/* TITLE */}
            <DialogTitle
              style={{
                textAlign: "center",
                fontWeight: 600
              }}
            >
              BOM File Creation and Auto Upload
            </DialogTitle>

            {/* CONTENT */}
            <DialogContent>
              <Box sx={{ overflowX: "auto" }}>
                <TableContainer>
                  <Table>
                    {/* TABLE HEAD */}
                    <TableHead>
                      <TableRow>
                        <TableCell align="center"><b>Project</b></TableCell>
                        <TableCell align="center"><b>BOM File Creation</b></TableCell>
                        <TableCell align="center"><b>View BOM</b></TableCell>
                        <TableCell align="center"><b>Auto Upload</b></TableCell>
                        <TableCell align="center"><b>Status</b></TableCell>
                        <TableCell align="center"><b>Approval Projects</b></TableCell>
                        <TableCell align="center"><b>Auto Upload Status</b></TableCell>
                      </TableRow>
                    </TableHead>

                    {/* TABLE BODY */}
                    <TableBody>
                      {selectedProjectObjects.map((project) => {
                        const isBomCreated =
                          Array.isArray(bomsCreated) &&
                          bomsCreated.some(
                            b =>
                              b.projectNumber === project.projectNumber &&
                              Array.isArray(b.bomItems) &&
                              b.bomItems.length > 0
                          );

                        const uploadedEntry = uploadedBoms.find(
                          b =>
                            b.projectNumber === project.projectNumber ||
                            b.projectId === project._id
                        );

                        const isUploaded = uploadedEntry?.uploaded === true;

                        // Find matching approval BOM
                        const approvalEntry = Array.isArray(allApprovalBoms) 
                          ? allApprovalBoms.find(
                              b => b.projectNumber === project.projectNumber
                            )
                          : null;

                        return (
                          <TableRow key={project._id}>
                            {/* PROJECT */}
                            <TableCell align="center">
                              {project.projectNumber}
                            </TableCell>

                            {/* BOM STATUS */}
                            <TableCell align="center">
                              {isBomCreated ? (
                                <CheckCircleIcon style={{ color: "green" }} />
                              ) : (
                                "-"
                              )}
                            </TableCell>

                            {/* VIEW BOM */}
                            <TableCell align="center">
                              {isBomCreated ? (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  startIcon={<VisibilityIcon />}
                                  onClick={() => handleViewBOM(project)}
                                >
                                  View
                                </Button>
                              ) : (
                                "-"
                              )}
                            </TableCell>

                            {/* AUTO UPLOAD STATUS */}
                            <TableCell align="center">
                              {isUploaded ? (
                                <CheckCircleIcon style={{ color: "green" }} />
                              ) : (
                                "-"
                              )}
                            </TableCell>

                            {/* STATUS TEXT */}
                            <TableCell align="center">
                              {isUploaded
                                ? "Uploaded to ERP"
                                : isBomCreated
                                ? "BOM Created"
                                : "Pending"}
                            </TableCell>

                            {/* APPROVAL PROJECTS - CHANGED */}
                            <TableCell align="center">
                              {approvalEntry ? approvalEntry.projectNumber : "-"}
                            </TableCell>

                            {/* APPROVAL STATUS - CHANGED */}
                            <TableCell align="center">
                                {!approvalEntry ? (
                                  "-"
                                ) : approvalEntry.approved === true ? (
                                  <>
                                    <CheckCircleIcon
                                      style={{ color: "green", verticalAlign: "middle" }}
                                    />{" "}
                                    Auto Approved
                                  </>
                                ) : (
                                  <>
                                    <CancelIcon
                                      style={{ color: "red", verticalAlign: "middle" }}
                                    />{" "}
                                    Not auto-approved due to unmet conditions or custom items are present;
                                    sent for manual approval.
                                  </>
                                )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </DialogContent>

            {/* ACTIONS */}
            <DialogActions
              style={{
                padding: "16px 24px",
                display: "grid",
                gridTemplateColumns: "1fr auto 1fr",
                alignItems: "center"
              }}
            >
              {/* LEFT EMPTY */}
              <Box />

              {/* CENTER BUTTONS */}
              <Box>
                <Button
                  variant="contained"
                  color="success"
                  disabled={!isSegregated}
                  onClick={bomFileCreationAPI}
                >
                  Create BOM File
                </Button>

                <Button
                  variant="contained"
                  color="success"
                  style={{ marginLeft: 16 }}
                  disabled={bomsCreated.length === 0 || autoApprovalBtnDisabled}
                  onClick={bomFileAutoUploadAPI}
                >
                  Auto Upload and Auto Approve
                </Button>

                {/* <Button
                  variant="contained"
                  color="success"
                  style={{ marginLeft: 16 }}
                  disabled={bomsCreated.length === 0}
                  // onClick={bomFileAutoUploadAPI}
                >
                  Auto Approve
                </Button> */}

              </Box>

              {/* RIGHT CLOSE */}
              <Box style={{ textAlign: "right" }}>
                <Button
                  variant="outlined"
                  onClick={() => setOpenERPDialog(false)}
                >
                  Close
                </Button>
              </Box>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openViewDialog}
            onClose={() => setOpenViewDialog(false)}
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle style={{ fontWeight: 600 }}>
              BOM Details – {viewProject?.projectNumber}
            </DialogTitle>

            <DialogContent>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell><b>Select Room</b></TableCell>
                      <TableCell><b>Select Scope</b></TableCell>
                      <TableCell><b>Scope Sub category</b></TableCell>
                      <TableCell><b>Select Material</b></TableCell>
                      <TableCell><b>UOM</b></TableCell>
                      <TableCell align="right"><b>Qty</b></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {viewBomData.length > 0 ? (
                      viewBomData.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row["Select Room"]}</TableCell>
                          <TableCell>{row["Select Scope"]}</TableCell>
                          <TableCell>{row["Scope Sub category"]}</TableCell>
                          <TableCell>{row["Select Material"]}</TableCell>
                          <TableCell>{row["UOM"]}</TableCell>
                          <TableCell align="right">{row["Qty"]}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No BOM data found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>

            <DialogActions>
              <Button variant="outlined" onClick={() => setOpenViewDialog(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>


        </Box>
      </>
    );
  };


export default connect(null, { setLoading, getApprovedProjects, setSnackInfo })(BomSegregation);